import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";
import * as TipoDeError from "../../isp._comun/services/Errores";

import DialogoServicioLayout from "./layouts/DialogoServicioLayout";

import ServicioReducer from "../reductores/ServicioReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";

import CargaDeServicioConsultado from "../reductores/acciones/dispatch/CargaDeServicioConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

// import { TipoDeItem } from "../../reductores/Constantes";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import ServicioRegistroDeServicio from "../../isp.žapi.servicios/ServiceRegistroDeServicio";
import ServicioActualizacionServicio from "../../isp.žapi.servicios/ServiceActualizacionServicio";
import ServicioQueryUnServicio from "../../isp.žapi.servicios/ServiceQueryUnServicio";
// import ComandoRegistrarServicio from "./ComandoRegistrarServicio";
// import ComandoActualizarItem from "./ComandoActualizarItem";

// import ServicioRegistroDeItem from "../../servicios/ServicioRegistroDeItem";
// import ServicioDeActualizacionDeItem from "../../servicios/ServicioDeActualizacionDeItem";
// import ServicioDeQueryDeUnItem from "../../servicios/ServicioDeQueryDeUnItem";
// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../isp._comun/iu/componentes/DataEstaticaDeRespuestas.json";
import DataDeRespuestas_Servicio from "./DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";
// import useHandlerDeComandoConSesionActiva from "../../../principal/componentes/presentadores/useHandlerDeComandoConSesionActiva";
// import ComandoBuscarUnItem from "./ComandoBuscarUnItem";

const DialogoServicio = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(ServicioReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    const servicioApiRegistrarServicio = new ServicioRegistroDeServicio();
    const registrarServicioCommand = new ComandoAPI(servicioApiRegistrarServicio);
    // const registrarItemCommand = new Comando();
    // registrarItemCommand.ejecutar = useHandlerDeComandoConSesionActiva(async function() {
    registrarServicioCommand.ejecutar = async () => {
        const servicio = {
            minicodigo: estadoDCF.domain.screen.minicodigo,
            idCliente: "CF00002",
            idPlan: "PL00001",
            idZona: "ZO000001",
            tipoComp: "FACT",
            cicloFact: "ULTM",
            modoCob: "ACT",
        };

        try {
            // const servicio = new ServicioRegistroDeItem();
            // registrarItemCommand.servicio = servicio;

            // const dataRegistradaDeItem = await servicio.ejecutar(item);
            const dataRegistradaDeItem = await servicioApiRegistrarServicio.ejecutar(servicio);
            // const dataRegistradaDeItem = await registrarItemCommand.servicio.ejecutar(item);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(item);
            dispatchDCF(new Action.CargaDeServicioRegistrado(dataRegistradaDeItem));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Servicio.CreacionServicio.titulo,
                    DataDeRespuestas_Servicio.CreacionServicio.mensaje,
                    dataRegistradaDeItem.idItem
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearServicio(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            // throw error;
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const servicioApiActualizarServicio = new ServicioActualizacionServicio();
    const actualizarServicioCommand = new ComandoAPI(servicioApiActualizarServicio);
    actualizarServicioCommand.ejecutar = async () => {
        // actualizarServicioCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
        const itemPorActualizar = {
            id: estadoDCF.domain.screen.idItem,
            data: estadoDCF.domain.update,
        };

        try {
            // const servicio = new ServicioDeActualizacionDeItem();
            // actualizarItemCommand.servicio = servicio;
            // const dataDeClienteActualizado =
            await servicioApiActualizarServicio.ejecutar(itemPorActualizar);
            dispatchDCF(
                new Action.CargaDeServicioActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarServicio(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
            }
            handleErroresExtraEnPrincipal(error);
            // throw error;
        }
    };

    const servicioApiQueryUnServicio = new ServicioQueryUnServicio();
    const buscarUnSoloServicioCommand = new ComandoAPI(servicioApiQueryUnServicio);

    buscarUnSoloServicioCommand.ejecutar = async (idItem) => {
        try {
            // const servicio = new ServicioDeQueryDeUnItem();
            // buscarUnSoloItemCommand.servicio = servicio;
            const respuestaQuery = await servicioApiQueryUnServicio.ejecutar(idItem);
            dispatchDCF(new CargaDeServicioConsultado(respuestaQuery.item));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    };

    return (
        <DialogoServicioLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            // registrarClienteAFacturar={useHandlerDeServicio(registrarClienteAFacturar)}
            registrarServicioCommand={registrarServicioCommand}
            // actualizarClienteAFacturar={useHandlerDeServicio(actualizarClienteAFacturar)}
            actualizarServicioCommand={actualizarServicioCommand}
            // buscarUnSoloClienteAFacturar={buscarUnSoloClienteAFacturar}
            buscarUnSoloServicioCommand={buscarUnSoloServicioCommand}
        />
    );
};

export default DialogoServicio;
